import { format, formatDistanceToNow } from 'date-fns';

function safeDate(value: string | number | Date): Date | null {
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function formatDate(value: string | number | Date): string {
  const d = safeDate(value);
  return d ? format(d, 'MMM dd, yyyy') : '—';
}

export function formatDateTime(value: string | number | Date): string {
  const d = safeDate(value);
  return d ? format(d, 'MMM dd, yyyy HH:mm') : '—';
}

export function formatRelative(value: string | number | Date): string {
  const d = safeDate(value);
  return d ? formatDistanceToNow(d, { addSuffix: true }) : '—';
}

/** Log-line precision: local time down to the millisecond, e.g. "Sep 24 10:15:02.123". */
export function formatLogTimestamp(value: string | number | Date): string {
  const d = safeDate(value);
  return d ? format(d, 'MMM dd HH:mm:ss.SSS') : '—';
}
